import { Component, computed, input } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { TableRow } from "@bitwarden/web-vault/app/components/tables/transaction-table/transaction-table";
import { DialogFactory } from "@bitwarden/web-vault/app/components/dialog/dialogFactory";
import { RIGHT_PANEL_CONFIG } from "@bitwarden/web-vault/app/models/constants/global.constants";

export interface TransactionData {
  alignTransac: number;
  statedBal: number;
  source: string;
  symbol: string;
}

export function getData(rowData: TableRow): TransactionData {
  return {
    alignTransac: rowData.amount,
    statedBal: rowData.balance,
    source: `${rowData.institution} - ${rowData.account}`,
    symbol: rowData.symbol,
  };
}

@Component({
  templateUrl: "./balance-alignment-transaction.component.html",
})
export class BalanceAlignmentTransactionComponent {
  rowData = input.required<TableRow>();
  private dialogFactory: DialogFactory;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BalanceAlignmentTransactionComponent>,
  ) {
    this.dialogFactory = new DialogFactory();
  }

  data = computed<TransactionData>(() => getData(this.rowData()));

  runningBal = computed<number>(() => {
    const { statedBal, alignTransac } = this.data();
    return statedBal - alignTransac;
  });

  openEditBalance(): void {
    const rowData = this.rowData();
    this.dialogFactory.statementBalanceDetails(rowData, this.dialogRef);
  }

  static open(
    rowData: TableRow,
    dialog: MatDialog,
    dialogRef?: MatDialogRef<DialogWrapperComponent>,
  ): void {
    dialogRef?.close();
    dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      disableClose: false,
      data: {
        title: "balanceAlignmentTransaction",
        showBackButton: false,
        component: BalanceAlignmentTransactionComponent,
        componentInputs: { rowData },
      },
    });
  }
}
